import { PaginationFooter } from '@calendly/ui/components/pagination-footer'

export const Pagination = ({ data, setPagePath, handleScrollToTableHeader }) => {
  if (!data?.pagination) return null

  const handlePrevious = () => {
    setPagePath(data.pagination.previousPage)
    handleScrollToTableHeader()
  }

  const handleNext = () => {
    setPagePath(data.pagination.nextPage)
    handleScrollToTableHeader()
  }

  return (
    <PaginationFooter
      onPreviousClick={data?.pagination.previousPage ? handlePrevious : null}
      onNextClick={data?.pagination.nextPage ? handleNext : null}
      totalCount={data?.pagination.count}
    />
  )
}
